import { RelatedTopicsList } from '../RelatedTopicsList';
import { RelatedTopicsData } from '../RelatedTopicsList/types';
import { TopicImagesCarousel } from './TopicImagesCarousel';

interface RelatedTopicsSectionProps {
  relatedTopicsData: RelatedTopicsData;
  seoVisible?: boolean;
}

export const RelatedTopicsSection: React.FC<RelatedTopicsSectionProps> = ({
  relatedTopicsData,
  seoVisible,
}) => {
  if (!relatedTopicsData) return null;

  if (relatedTopicsData.hasImages) {
    return <TopicImagesCarousel topics={relatedTopicsData.bubbles} />;
  }

  return (
    <RelatedTopicsList
      topics={relatedTopicsData.bubbles}
      seoVisible={seoVisible}
    />
  );
};
